module.exports = __webpack_public_path__ + "img/4.56407d06.jpeg";